import { ShoppingCartOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const CartPage = lazyRouteComponent(() => import('./pages/cart'));

export const getRoutes = (): Route[] => [
  {
    page: CartPage,
    path: ROUTE_PATHS.CART,
    title: 'Carrinho',
    icon: ShoppingCartOutlined,
    hidden: true,
  },
];
